import { Locale } from 'date-fns';
import { arEG, enGB, fr, is, pl } from 'date-fns/locale/index.js';
import { useEffect, useState } from 'react';

import { company } from '~/company/Company';
import { getCookieLang } from '~/utils/cookies';

const LOCALES = {
  en: enGB,
  ar: arEG,
  is,
  pl,
  fr,
};

export const useDateLang = (): { locale: Locale } => {
  const [dateLang, setDateLang] = useState(
    LOCALES[getCookieLang() as keyof typeof LOCALES] ??
      LOCALES[company.config.lang as keyof typeof LOCALES] ??
      enGB,
  );
  const currentLang = getCookieLang();

  useEffect(() => {
    setDateLang(
      LOCALES[currentLang as keyof typeof LOCALES] ??
        LOCALES[company.config.lang as keyof typeof LOCALES] ??
        enGB,
    );
  }, [currentLang]);

  return { locale: dateLang };
};
